// One-use navigation preference from an explicit click: «voice» opens the session in Conversar, «text» only focuses.
let pending: 'text' | 'voice' | null = null;
export function setConversationIntent(intent: 'text' | 'voice'): void { pending = intent; }
export function takeConversationIntent(): 'text' | 'voice' | null {
  const intent = pending; pending = null; return intent;
}
